import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择春色影视
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            四大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center group hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 mx-auto mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-primary-600 group-hover:text-background-50 text-2xl transition-colors duration-300`}></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-base mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}